import { mapActions } from 'vuex'
export const steps_create_mission = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="1"]',
    content: 'Click on <strong>Select</strong> to pick a parametric study.',
    params: {
      placement: 'bottom'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="2"]',
    content: 'Click on <strong>Select</strong> to pick an orbital transfer.',
    params: {
      placement: 'bottom'
    }
  }
]
export const defaultValueAnaMission = ['Orbital transfer mission test']
export const steps_analytical_mission = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="3"]',
    content:
      'You will now create your orbital transfer mission. Firstly, give a name to your mission.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="4"]',
    content:
      'Now click on the spacecraft field and select <strong>create new Spacecraft</strong>.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="19"]',
    content: 'Your mission now contains the created spacecraft.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="30"]',
    content: 'Select the previously created initial orbit.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="31"]',
    content: 'Select the previously created final orbit.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="32"]',
    content: '<strong>Save</strong> your mission.'
  }
]
export const defaultValueAnaSC = ['spacecraft test', 50, 1500, 50]
export const steps_analytical_spacecraft = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="5"]',
    content: 'Give a <strong>Name</strong> to your spacecraft.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="6"]',
    content: 'Write down the desired <strong>Platform mass</strong> (e.g 50).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="7"]',
    content:
      'Select <strong>define drag model</strong> and write down values for the <strong>Drag area</strong> (e.g 1500) and for the <strong>drag coefficient</strong> (e.g 2.2).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="8"]',
    content:
      'Write down the desired <strong>Orbital average power</strong> (e.g 50).'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="9"]',
    content:
      'Now click on the <strong>Propulsion system</strong> field and select <strong>create new Propulsion system</strong>.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="18"]',
    content:
      'Your spacecraft now contains the created propulsion system, <strong>Save</strong> your spacecraft.'
  }
]
export const defaultValueAnaPS = [
  'thruster test',
  7,
  1000,
  150,
  2.8,
  'UNLIMITED',
  0.001
]
export const steps_analytical_propulsion_system = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="10"]',
    content: 'Give a <strong>Name</strong> to your propulsion system.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="11"]',
    content: 'Write down the desired <strong>Nominal thrust</strong> (e.g 7).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="12"]',
    content:
      'Write down the desired <strong>Specific impluse</strong> (e.g 1000).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="13"]',
    content: 'Write down the desired <strong>Nominal power</strong> (e.g 150).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="14"]',
    content:
      'Write down the desired <strong>Total mass including propellant</strong> (e.g 2.8).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="15"]',
    content: 'Set propellant capacity to <strong>UNLIMITED</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="16"]',
    content: 'Write down the desired <strong>price</strong> (e.g 0.001).',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="17"]',
    content:
      'You should now be able to create your spacecraft by clicking on <strong>Create</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  }
]

export const steps_side_navigation = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="20"]',
    content:
      'This is the side navigation bar, click on the <strong>spacecraft icon</strong> to check that your spacecraft has been added to the list of parametric spacecraft.',
    params: {
      placement: 'right-end'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="21"]',
    content:
      'Now, click on the <strong>sphere icon</strong> to go to the orbit panel.',
    params: {
      placement: 'right-end'
    }
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="29"]',
    content:
      'Click on the <strong>wheel icon</strong> to go to the mission configuration panel.',
    params: {
      placement: 'right-end'
    }
  }
]

export const defaultValueAnaOrbit = [
  'Initial orbit test',
  '580',
  'Final orbit test',
  '700'
]
export const steps_analytical_orbit = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="22"]',
    content: 'Here you see all the orbits already created.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="23"]',
    content:
      'Click on <strong>New orbit</strong> to create a new one, it will serve as the orbit transfer initial orbit.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="24"]',
    content: 'Give a name to your orbit (e.g Initial orbit test).'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="25"]',
    content: 'Write down the desired altitude (e.g 580).'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="26"]',
    content: 'Click on <strong>Create</strong> to save this orbit.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="27"]',
    content:
      'Click on <strong>New orbit</strong> again to create your final orbit.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="28"]',
    content: 'Fill in required fields and click <strong>Create</strong>.',
    params: {
      placement: 'left'
    }
  }
]
export const steps_analytical_dashboard = [
  {
    target: '[gt_ParamOrbitTransfert1-v-step="33"]',
    content: 'Click on <strong>Start computation</strong> to see the results.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="34"]',
    content:
      'Click on <strong>View</strong> to see the detailled results of your mission.'
  },
  {
    target: '[gt_ParamOrbitTransfert1-v-step="35"]',
    content: 'Congratulations ! You have finished this tutorial.'
  }
]
export default {
  ...mapActions(['start_gt_OrbitTransferParam1']),
  setDefaultTourValue(component, list, field, index) {
    component.inputs[field] =
      component.inputs[field] === '' ? list[index] : component.inputs[field]
  },
  onNextStepAnaMission(currentStep, component) {
    if (currentStep === 0) {
      this.setDefaultTourValue(component, defaultValueAnaMission, 'name', 0)
    } else if (currentStep === 1) {
      if (component.inputs.spacecraft === null) {
        component.$tours['paramOrbitalTransfer1TourAnaMission'].start(1)
      } else {
        component.gt_OrbitTransferParam1.firstSpacecraftTourDone = true
        component.gt_OrbitTransferParam1.secondSpacecraftTourDone = true
        component.gt_OrbitTransferParam1.thrusterTourDone = true
      }
    } else if (currentStep === 2) {
      component.gt_OrbitTransferParam1.secondMissionTourDone = true
    } else if (currentStep === 3) {
      if (component.inputs.initialOrbit === null) {
        component.$tours['paramOrbitalTransfer1TourAnaMission'].start(3)
      }
    } else if (currentStep === 4) {
      if (component.inputs.finalOrbit === null) {
        component.$tours['paramOrbitalTransfer1TourAnaMission'].start(4)
      }
    }
  },
  onFinishAnaMission(component) {
    if (component.inputsValid) {
      component.submitForm()
    }
  },
  onSkipCreateMission(component) {
    component.redirectToMissionSetting('ParametricStudyRequest')
    let mission = {
      type: 'Orbital Transfer',
      typeName: 'ParametricStudyRequest'
    }
    component.sendMissionEvent('create-mission', mission)
  },
  beginParamOrbitalTranfer1Tour(component) {
    if (component.gt_OrbitTransferParam1.firstMissionTourDone) {
      if (!component.gt_OrbitTransferParam1.secondMissionTourDone) {
        component.$tours['paramOrbitalTransfer1TourAnaMission'].start(2)
      } else {
        component.$tours['paramOrbitalTransfer1TourAnaMission'].start(3)
        component.gt_OrbitTransferParam1.thirdMissionTourDone = true
      }
    } else {
      component.$tours['paramOrbitalTransfer1TourAnaMission'].start()
      component.gt_OrbitTransferParam1.firstMissionTourDone = true
    }
  },
  onNextStepAnaSC(currentStep, component) {
    if (currentStep === 0) {
      this.setDefaultTourValue(component, defaultValueAnaSC, 'name', 0)
    } else if (currentStep === 1) {
      this.setDefaultTourValue(component, defaultValueAnaSC, 'platformMass', 1)
    } else if (currentStep === 2) {
      component.inputs.dragModelDefined = true
      this.setDefaultTourValue(component, defaultValueAnaSC, 'dragArea', 2)
    } else if (currentStep === 3) {
      this.setDefaultTourValue(
        component,
        defaultValueAnaSC,
        'orbitalAveragePower',
        3
      )
    } else if (currentStep === 4) {
      if (component.inputs.thruster === null) {
        component.$tours['paramOrbitalTransfer1TourAnaSC'].start(4)
      } else {
        component.gt_OrbitTransferParam1.thrusterTourDone = true
        component.gt_OrbitTransferParam1.secondSpacecraftTourDone = true
        component.$tours['paramOrbitalTransfer1TourAnaSC'].start(5)
      }
    }
  },
  onSkipAnaSC(component) {
    this.setDefaultTourValue(component, defaultValueAnaSC, 'name', 0)
    this.setDefaultTourValue(component, defaultValueAnaSC, 'platformMass', 1)
    component.inputs.dragModelDefined = true
    this.setDefaultTourValue(component, defaultValueAnaSC, 'dragArea', 2)
    this.setDefaultTourValue(
      component,
      defaultValueAnaSC,
      'orbitalAveragePower',
      3
    )
    if (component.inputs.thruster === null) {
      component.$tours['paramOrbitalTransfer1TourAnaSC'].start(4)
    } else {
      component.gt_OrbitTransferParam1.thrusterTourDone = true
      component.gt_OrbitTransferParam1.secondSpacecraftTourDone = true
      component.submitForm()
    }
  },
  beginTourAnaSC(component) {
    component.gt_OrbitTransferParam1.firstSpacecraftTourDone = true
    if (component.gt_OrbitTransferParam1.thrusterTourDone) {
      component.gt_OrbitTransferParam1.secondSpacecraftTourDone = true
      component.$tours['paramOrbitalTransfer1TourAnaSC'].start(5)
    } else {
      component.$tours['paramOrbitalTransfer1TourAnaSC'].start()
    }
  },
  onNextStepAnaPS(currentStep, component) {
    if (currentStep === 0) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'name', 0)
    } else if (currentStep === 1) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'thrust', 1)
    } else if (currentStep === 2) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'isp', 2)
    } else if (currentStep === 3) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'power', 3)
    } else if (currentStep === 4) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'totalMass', 4)
    } else if (currentStep === 5) {
      component.inputs.propellantCapacityChoice =
        component.inputs.propellantCapacityChoice === 'PROPELLANT' &&
        component.inputs.propellantMass === ''
          ? defaultValueAnaPS[5]
          : component.inputs.propellantCapacityChoice
    } else if (currentStep === 6) {
      this.setDefaultTourValue(component, defaultValueAnaPS, 'cost', 6)
    }
  },
  onSkipAnaPS(component) {
    this.setDefaultTourValue(component, defaultValueAnaPS, 'name', 0)
    this.setDefaultTourValue(component, defaultValueAnaPS, 'thrust', 1)
    this.setDefaultTourValue(component, defaultValueAnaPS, 'isp', 2)
    this.setDefaultTourValue(component, defaultValueAnaPS, 'power', 3)
    this.setDefaultTourValue(component, defaultValueAnaPS, 'totalMass', 4)
    component.inputs.propellantCapacityChoice =
      component.inputs.propellantCapacityChoice === 'PROPELLANT' &&
      component.inputs.propellantMass === ''
        ? defaultValueAnaPS[5]
        : component.inputs.propellantCapacityChoice
    this.setDefaultTourValue(component, defaultValueAnaPS, 'cost', 6)
    component.submitForm()
  },
  onNextStepAnaOrbit(currentStep, component) {
    if (currentStep === 1) {
      component.inputs.displayForm = true
    } else if (currentStep === 2) {
      this.setDefaultTourValue(component, defaultValueAnaOrbit, 'name', 0)
    } else if (currentStep === 3) {
      this.setDefaultTourValue(component, defaultValueAnaOrbit, 'altitude', 1)
    } else if (currentStep === 4) {
      component.submitForm()
    } else if (currentStep === 5) {
      component.inputs.displayForm = true
    }
  },
  onFinishAnaOrbit(component) {
    this.setDefaultTourValue(component, defaultValueAnaOrbit, 'name', 2)
    this.setDefaultTourValue(component, defaultValueAnaOrbit, 'altitude', 3)
    component.submitForm()
    component.gt_OrbitTransferParam1.orbitsTourDone = true
  },
  onNextStepSideNav(currentStep, component, route) {
    if (currentStep === 0) {
      route.$router.push('/analyticalspacecraft')
    } else if (currentStep === 1) {
      component.gt_OrbitTransferParam1.firstSideNavTourDone = true
      route.$router.push('/analyticalorbit')
    }
  },

  onNextAnaDashboard(currentStep, component) {
    if (component.displayComputationWidget) {
      component.$tours['paramOrbitalTransfer1TourResult'].start()
    } else if (currentStep === 0 && component.displayResult) {
      component.$tours['paramOrbitalTransfer1TourResult'].start(1)
    }
  },

  stopAllTours(component) {
    for (const key of Object.keys(component.gt_OrbitTransferParam1)) {
      component.start_gt_OrbitTransferParam1({ param: key, val: false })
    }
    for (const tour in component.$tours) {
      component.$tours[tour].stop()
    }
  }
}
